'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { SerializedError } from '@reduxjs/toolkit';

type ApiError = FetchBaseQueryError | SerializedError | undefined;

const getErrorMessage = (error: ApiError): string => {
  if (
    error &&
    'data' in error &&
    error.data &&
    typeof error.data === 'object' &&
    'error_message' in error.data
  ) {
    return (error.data as { error_message: string }).error_message;
  }
  return 'An error occurred while loading data. Please try again.';
};

interface AnalyticsErrorOverlayProps {
  error: ApiError;
  isVisible: boolean;
}

const AnalyticsErrorOverlay: React.FC<AnalyticsErrorOverlayProps> = ({
  error,
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <div
      className="absolute inset-0 z-30 bg-white flex items-center justify-center"
      role="alert"
      data-testid="analytics-error-overlay"
    >
      <div className="flex flex-col items-center justify-center gap-2 px-8 text-center">
        <Icon
          icon={faExclamationTriangle}
          className="text-2xl text-red-400"
        />
        <span className="text-sm font-medium text-red-600">
          {getErrorMessage(error)}
        </span>
      </div>
    </div>
  );
};

export default AnalyticsErrorOverlay;
